import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const ProcesosPOCRACI = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-POC-RACI.pdf`;
  /*const pdfUrl = "/pdf/proceso-POC-RACI.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Proceso Comercial Completo - Diagrama</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Proceso Comercial Completo - Diagrama" />
      </Container>
    </>
  );
};

 export default ProcesosPOCRACI;
